import { Component, OnInit } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { ToastrService } from 'ngx-toastr'

@Component({
    selector: 'app-reject-modal',
    templateUrl: './reject-modal.component.html',
    styleUrls: ['./reject-modal.component.scss'],
})
export class RejectModalComponent implements OnInit {
    rejectJustification: string = ''

    constructor(private activeModal: NgbActiveModal, private toastr: ToastrService) {}

    ngOnInit(): void {}

    handleClose() {
        this.activeModal.close()
    }

    confirmReject() {
        if (!this.rejectJustification) {
            this.toastr.error('Informe a justificativa para rejeitar a solicitação')
            return
        }

        if (this.rejectJustification.length < 50) {
            this.toastr.error('O motivo da rejeição deve ter pelo menos 50 caracteres')
            return
        }

        this.activeModal.close({
            justification: this.rejectJustification,
        })
    }
}
